/* Hide Fast Simon prices for EU visitors */
(function () {
  if (window.__harbourEuHidePrices) return;
  window.__harbourEuHidePrices = true;

  var STYLE_ID = 'harbour-eu-hide-prices';
  var CSS = [
    '.fs-serp-price{display:none!important}',            /* search results price */
    '.fs-product-price-wrapper{display:none!important}', /* autocomplete price */
    '#fs_filter_price{display:none!important}',          /* price range filter */
    '.fs-custom-option[data-value="price_min_to_max"],.fs-custom-option[data-value="price_max_to_min"]{display:none!important}' /* price sort options */
  ].join('\n');
  var HOSTS = '#fast-simon-serp-app, #serp-portal, .fast-ac-container, .mobile-fast-ac-container';

  function isEu() {
    return document.documentElement.classList.contains('eu-visitor');
  }

  function apply() {
    if (!isEu()) return;
    var hosts = document.querySelectorAll(HOSTS);
    for (var i = 0; i < hosts.length; i++) {
      var root = hosts[i].shadowRoot;
      if (!root || root.getElementById(STYLE_ID)) continue;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; apply(); }, 50);
  }

  apply();
  document.addEventListener('harbour:eu-visitor-detected', apply);
  window.addEventListener('fast-serp-ready', schedule);
  window.addEventListener('fs-custom-events-results-rendered', schedule);

  function observeBody() {
    new MutationObserver(function () { if (isEu()) schedule(); })
      .observe(document.body, { childList: true });
  }
  if (document.body) observeBody();
  else document.addEventListener('DOMContentLoaded', observeBody);
})();
